import { h } from "preact";
import styles from "./HappinessSubmitterPage.scss";

import { HappinessSubmitter } from "../components/happinessSubmitter";
import { HappinessMenu, menuOptions } from "../../menu";
import { ON_MOBILE_DEVICE } from "../../../config";

const HappinessSubmitterPage = () => {
  const menu = (
    <HappinessMenu
      key="menu"
      headerText={"Add an entry"}
      selectedPage={menuOptions.HAPPINESS_SUBMITTER}
    />
  );
  const components = [<HappinessSubmitter key="submitter" />];

  ON_MOBILE_DEVICE() ? components.push(menu) : components.unshift(menu);

  return <div className={styles.container}>{components}</div>;
};

export default HappinessSubmitterPage;



// WEBPACK FOOTER //
// ./src/modules/diary/pages/HappinessSubmitterPage.js